import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';
import { StudentsRemovalRequestDetailModal } from '../StudentsRemovalRequestDetail/StudentsRemovalRequestDetailModal';
import { StudentsRemovalRequestCreateModal } from '../StudentsRemovalRequestForm/StudentsRemovalRequestCreateModal';
import { StudentsRemovalRequestFilters } from './StudentsRemovalRequestStudentsFilters';
import {
  StudentsRemovalRequestStudentsListConsumer,
  StudentsRemovalRequestStudentsListLoader,
} from './StudentsRemovalRequestStudentsListLoader';
import { StudentsRemovalRequestStudentsTable } from './StudentsRemovalRequestStudentsTable';
import { StudentsRemovalRequestStudentsTablePagination } from './StudentsRemovalRequestStudentsTablePagination';

export function StudentsRemovalRequestStudents() {
  const { t } = useTranslation(
    TranslationsKeys.STUDENT_MANAGEMENT_STUDENT_REMOVAL_REQUEST_STUDENTS,
  );
  const texts = useMemo(() => {
    return {
      body: t('students.body'),
    };
  }, [t]);
  const [openCreate, setOpenCreate] = useState<{
    studyPlanEnrollmentId: number;
  }>();
  const [openDetail, setOpenDetail] = useState<{
    studyPlanEnrollmentId: number;
  }>();
  const onCreateRequest = useCallback((studyPlanEnrollmentId: number) => {
    setOpenCreate({ studyPlanEnrollmentId });
  }, []);
  const onViewDetail = useCallback((studyPlanEnrollmentId: number) => {
    setOpenDetail({ studyPlanEnrollmentId });
  }, []);

  return (
    <>
      <StudentsRemovalRequestStudentsListLoader>
        <p>{texts.body}</p>
        <StudentsRemovalRequestFilters />
        <StudentsRemovalRequestStudentsListConsumer>
          {({ data, loading, refresh }) => {
            return (
              <>
                <StudentsRemovalRequestStudentsTable
                  data={data?.data ?? []}
                  loading={loading}
                  onCreateRequest={onCreateRequest}
                  onViewDetail={onViewDetail}
                />
                {!!data && !loading && data.total_pages > 1 && (
                  <StudentsRemovalRequestStudentsTablePagination
                    total={data.total}
                    totalPages={data.total_pages}
                  />
                )}
                {openCreate && (
                  <StudentsRemovalRequestCreateModal
                    studyPlanEnrollmentId={openCreate.studyPlanEnrollmentId}
                    onClose={(success) => {
                      if (success) {
                        refresh();
                      }
                      setOpenCreate(undefined);
                    }}
                  />
                )}
                {openDetail && (
                  <StudentsRemovalRequestDetailModal
                    studyPlanEnrollmentId={openDetail.studyPlanEnrollmentId}
                    onClose={() => {
                      setOpenDetail(undefined);
                    }}
                  />
                )}
              </>
            );
          }}
        </StudentsRemovalRequestStudentsListConsumer>
      </StudentsRemovalRequestStudentsListLoader>
    </>
  );
}
